import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vehicle_2mXdc",
  "use": "vehicle_2mXdc-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vehicle_2mXdc\">\n    <path d=\"M3 13h18l-2-5h-8l-2 5z\" stroke=\"currentColor\" fill=\"none\" />\n    <circle cx=\"7\" cy=\"17\" r=\"2\" stroke=\"currentColor\" fill=\"none\" />\n    <circle cx=\"17\" cy=\"17\" r=\"2\" stroke=\"currentColor\" fill=\"none\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol